import { jwtDecode } from "jwt-decode";

export const readJwtToken = (token: string) => {
  try {
    // Decode the token
    const decodedToken = jwtDecode(token);

    // Return the decoded payload
    return decodedToken;
  } catch (error) {
    console.error("Invalid token:", error);
    return {};
  }
};
